import {Router} from "@/rawdogjs/src/router";

export class Routes {

    public static register(router: Router, updateAppView: any, renderComponent: any) {
        router.on(
            "/login",
            async () => {
                await updateAppView(await renderComponent.render("login"));
            }
        );

        router.on(
            "/home",
            async () => {
                await updateAppView(await renderComponent.render("/home"));
            }
        );

        router.on(
            "/",
            async () => {
                await updateAppView(await renderComponent.render("/home"));
            }
        );

        router.on(
            "/drywallio/hello-world",
            async () => {
                await updateAppView(await renderComponent.render("/drywallio/helloWorld"));
            }
        );


        router.on(
            "/drywallio/home",
            async () => {
                await updateAppView(await renderComponent.render("/drywallio/homeMenu"));
            }
        );

        router.on(
            "/resetPassword",
            async () => {
                await updateAppView(await renderComponent.render("resetPassword"));
            }
        );


        router.on(
            "/signUp",
            async () => {
                await updateAppView(await renderComponent.render("signUp"));
            }
        );

        router.on(
            "/drywallio/capture-email",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/captureEmail"));
            }
        );

        router.on(
            "/drywallio/schedule-date",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/scheduleDate"));
            }
        );

        router.on(
            "/drywallio/schedule-time",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/scheduleTime"));
            }
        );


        router.on(
            "/drywallio/add-address",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/addAddress"));
            }
        );


        router.on(
            "/drywallio/contact",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/contactStep"));
            }
        );

        router.on(
            "/drywallio/booking-confirmation",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/bookingConfirmation"));
            }
        );


        router.on(
            "/drywallio/create-dating-profile",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/createDatingProfile"));
            }
        );

        router.on(
            "/drywallio/cleaning-calculator",
            async () => {
                await updateAppView(await renderComponent.render("drywallio/cleaningCalculator"));
            }
        );

        router.resolve(); // initial load
    }

}